import React from 'react'

import { IconBase } from '../IconBase'
import { IconProps } from '../types'

export const ChevronDown: React.FC<IconProps> = (props) => (
  <IconBase {...props}>
    <path
      d="M6 9L12 15L18 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
